import React from 'react';
import styled from 'styled-components';
import { Formik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { getTranslatedString } from 'helpers/i18n';
import Properties from './fields/Properties';
import Name from './fields/Name';
import Details from './fields/Details';
import Link from './fields/Link';
import ExpiryDate from './fields/ExpiryDate';
import NotifyResidents from './fields/NotifyResidents';
import ExternalPromotion from './fields/ExternalPromotion';
import Photo from './fields/Photo';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import { validUrlRegex } from 'helpers/Validator';
import { VerticalFormWrapper } from 'components/ui/VerticalFormWrapper';

import { emptyStringToNull } from 'helpers/Formatter';

const StyledSectionContainer = styled.div`
  margin-bottom: 32px;
`;

const PromotionForm = ({ formName, formData, handleSubmit }) => {
  const validateForm = async (values) => {
    const requiredErrorVerbiage = getTranslatedString('required');
    let validationSchema = {
      properties: Yup.string().required(requiredErrorVerbiage),
      name: Yup.string().required(requiredErrorVerbiage),
      description: Yup.string().required(requiredErrorVerbiage),
      link: Yup.string()
        .matches(validUrlRegex, getTranslatedString('invalidURL'))
        .transform(emptyStringToNull)
        .nullable(),
      expiration_date: Yup.date().required(requiredErrorVerbiage),
      image: Yup.mixed().required(getTranslatedString('landlordPortal.promotions.fileRequired')),
    };
    const schema = Yup.object().shape(validationSchema);
    return schema.validate(values, { abortEarly: false }).catch((error) => {
      throw yupToFormErrors(error);
    });
  };

  const initialValues = {
    id: formData.id || undefined,
    properties: formData.properties || [],
    name: formData.name || undefined,
    description: formData.description || undefined,
    link: formData.link || undefined,
    expiration_date: formData.expiration_date || undefined,
    notify_residents: formData.notify_residents || false,
    is_external: formData.is_external || false,
    vendor: formData.vendor || undefined,
    image: formData.image || undefined,
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validateForm}
      enableReinitialize
    >
      {({ handleSubmit, ...rest }) => (
        <VerticalFormWrapper id={formName} onSubmit={handleSubmit}>
          <StyledSectionContainer>
            <Properties {...rest} />
            <Name {...rest} />
            <Details {...rest} />
            <Spacer mb={1}>
              <Row gutter={16}>
                <Link {...rest} />
                <ExpiryDate {...rest} />
              </Row>
            </Spacer>
            <NotifyResidents {...rest} />
            <ExternalPromotion {...rest} />
            <Photo {...rest} />
          </StyledSectionContainer>
        </VerticalFormWrapper>
      )}
    </Formik>
  );
};

export default PromotionForm;
